/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'

import './RecurrencePattern.css'

interface RecurrencePatternProps {
  activateEdit: boolean
  eventRRule: null | string
  getRRule: (rrule: any) => void
  isEdit: any
  patternError: string
  rangeError: string
  rrule: {
    dtstartTime: any
    untilTime: any
  }
}
const RecurrencePattern = (props: RecurrencePatternProps) => {
  const [rrule, setRRule] = useState({
    bymonth: 1,
    bymonthday: 1,
    bysetpos: 1,
    byweekday: [] as string[],
    count: 0,
    dtstart: '' as any,
    freq: '',
    interval: 1,
    isNoEndDate: false,
    until: '' as any,
  })
  const eventRule = props?.eventRRule && JSON.parse(props?.eventRRule)
  const todayDate = new Date().toISOString().split('T')[0]

  const [byMonth, setByMonth] = useState()
  const [byMonthDay, setByMonthDay] = useState()
  const [bySetPos, setBySetPos] = useState()

  const [frequency, setFrequency] = useState('daily')
  const [isNoEndDate, setIsNoEndDate] = useState(false)
  //Recurrence Pattern
  const [isDailySelected, setIsDailySelected] = useState({
    everyDay: false,
    weekDaysSelected: false,
  })
  const [isMontlySelected, setisMontlySelected] = useState({
    customDays: false,
    days: false,
  })
  const [byWeekDays, setByWeekDays] = useState([])
  const [interval, setInterval] = useState(0)
  const [isYearlySelected, setIsYearlySelected] = useState({
    monthSelected: false,
    weekDaysSelected: false,
  })
  //Range of recurrence
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [endRadioSelection, setEndRadioSelection] = useState(null)
  const [count, setCount] = useState(0)
  const [dateRange, setDateRange] = useState(null)

  useEffect(() => {
    if (eventRule) {
      setFrequency(eventRule.freq)

      frequencySetter()
      setStartDate(new Date(eventRule.dtstart).toISOString().split('T')[0])

      if (eventRule.count) {
        setEndRadioSelection('endAfterCount')
        setEndDate(null)
        setDateRange(1)
        setCount(eventRule.count)
      } else if (eventRule.until && !eventRule.isNoEndDate) {
        setEndRadioSelection('endBy')
        setCount(null)
        setDateRange(2)
        setEndDate(new Date(eventRule.until).toISOString().split('T')[0])
      } else {
        setEndRadioSelection('noEndDate')
        setCount(null)
        setEndDate(null)
        setDateRange(0)
      }
      if (eventRule.bymonth && eventRule.freq === 'yearly') {
        setIsYearlySelected({
          monthSelected: true,
          weekDaysSelected: false,
        })
      } else if (eventRule.byweekday.length > 0 && eventRule.freq === 'yearly') {
        setIsYearlySelected({
          monthSelected: false,
          weekDaysSelected: true,
        })
      }else if(eventRule.byweekday.length > 0 && eventRule.freq === 'monthly'){
        setisMontlySelected({
          customDays : true,
          days: false
        })
      }else if(eventRule.byweekday.length === 0 && eventRule.freq === 'monthly'){
        setisMontlySelected({
          customDays : false,
          days: true
        })
      }
    } else {
     setIsDailySelected({
      everyDay : false,
      weekDaysSelected : false
     })
      setFrequency('daily')
      setInterval(null)
      setByWeekDays([])
      setBySetPos(null)
      setByMonthDay(null)
      setByMonth(null)
      setCount(null)
      setStartDate(null)
      setEndDate(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const frequencySetter = () => {
    switch (eventRule.freq) {
      case 'daily':
        if (eventRule.byweekday?.length === 5) {
          radioSelectHandler(1)
          setIsDailySelected({
            everyDay : false,
            weekDaysSelected : true
          })
        } else {
          radioSelectHandler(0)
          setIsDailySelected({
            everyDay : true,
            weekDaysSelected : false
          })
          setInterval(eventRule.interval)
        }
        break

      case 'weekly':
        setInterval(eventRule.interval)
        setByWeekDays(eventRule.byweekday)
        break

      case 'monthly':
        if (eventRule.bymonthday) {
          setByMonthDay(eventRule.bymonthday)
          setInterval(eventRule.interval)
        } else {
          setInterval(eventRule.interval)
          setByWeekDays(eventRule.byweekday)
          setBySetPos(eventRule.bysetpos)
        }
        break

      case 'yearly':
        setInterval(eventRule.interval)
        setByMonth(eventRule.bymonth)
        if (eventRule.bymonthday) {
          setByMonthDay(eventRule.bymonthday)
        } else {
          setBySetPos(eventRule.bysetpos)
          setByWeekDays(eventRule.byweekday)
        }
        break

      default:
        break
    }
  }
  useEffect(() => {
    const rruleData = {
      bymonth: byMonth as number,
      bymonthday: byMonthDay as number,
      bysetpos: bySetPos as number,
      byweekday: byWeekDays,
      count: count as number,
      dtstart: startDate + props.rrule.dtstartTime,
      endRadioSelection: endRadioSelection,
      freq: frequency,
      interval: interval as number,
      isNoEndDate: isNoEndDate,
      until: endDate + props.rrule.untilTime,
    }
    if (endRadioSelection === 'noEndDate' || endRadioSelection === 'endAfterCount') {
      const today = new Date()
      today.setFullYear(today.getFullYear() + 10)
      rruleData.until = today.toISOString().split('T')[0] + props.rrule.untilTime
    } else if (endRadioSelection === 'endBy') {
      rruleData.until = endDate + props.rrule.untilTime
    }
    setRRule(rruleData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    byMonth,
    byMonthDay,
    bySetPos,
    byWeekDays,
    isNoEndDate,
    count,
    endDate,
    frequency,
    interval,
    endRadioSelection,
    props.rrule,
    startDate,
  ])
  useEffect(() => {
    if (!props.isEdit) {
      setFrequency('daily')
      setInterval(null)
    }
  }, [props.isEdit])

  const sendDataToParent = () => {
    props.getRRule(rrule)
  }

  useEffect(() => {
    sendDataToParent()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rrule, props.rrule])

  const frequencySelectHandler = (input: string) => {
    setFrequency(input)
    setInterval(null)
    setByWeekDays([])
    setBySetPos(null)
    setByMonthDay(null)
    setByMonth(null)
  }

  const frequencyDropdown = [
    { ID: 0, label: 'First', value: 1 },
    { ID: 1, label: 'Second', value: 2 },
    { ID: 2, label: 'Third', value: 3 },
    { ID: 3, label: 'Fourth', value: 4 },
    { ID: 4, label: 'Last', value: -1 },
  ]
  const weekdayDropdown = [
    { ID: 0, label: 'Sunday', value: 'su' },
    { ID: 1, label: 'Monday', value: 'mo' },
    { ID: 2, label: 'Tuesday', value: 'tu' },
    { ID: 3, label: 'Wednesday', value: 'we' },
    { ID: 4, label: 'Thursday', value: 'th' },
    { ID: 5, label: 'Friday', value: 'fr' },
    { ID: 6, label: 'Saturday', value: 'sa' },
  ]
  const monthlyDropdown = [
    { ID: 0, label: 'January', value: 1 },
    { ID: 0, label: 'February', value: 2 },
    { ID: 0, label: 'March', value: 3 },
    { ID: 0, label: 'April', value: 4 },
    { ID: 0, label: 'May', value: 5 },
    { ID: 0, label: 'June', value: 6 },
    { ID: 0, label: 'July', value: 7 },
    { ID: 0, label: 'August', value: 8 },
    { ID: 0, label: 'September', value: 9 },
    { ID: 0, label: 'October', value: 10 },
    { ID: 0, label: 'November', value: 11 },
    { ID: 0, label: 'December', value: 12 },
  ]

  const setBySetPosHandler = (event) => setBySetPos(parseInt(event.target.value))
  const setByWeekDayHandler = (event) => setByWeekDays([event.target.value])
  const setByMonthHandler = (event) => setByMonth(parseInt(event.target.value))

  const intervalChoice = frequencyDropdown?.map((e) => {
    return (
      <option key={e.ID} value={e.value}>
        {e.label}
      </option>
    )
  })
  const singleDayChoice = weekdayDropdown?.map((e) => {
    return (
      <option key={e.ID} value={e.value}>
        {e.label}
      </option>
    )
  })
  const monthChoice = monthlyDropdown?.map((e) => {
    return (
      <option key={e.ID} value={e.value}>
        {e.label}
      </option>
    )
  })

  const frequencyChoiceHandler = (event: any) => {
    setInterval(parseInt(event.target.value))
  }
  const byMonthDaySelect = (event: any) => {
    setByMonthDay(parseInt(event.target.value))
  }

  const radioSelectHandler = (input: number) => {
    const getElementValue = (id: string) => {
      const element = document.getElementById(id) as HTMLInputElement | null
      return element ? element.value : ''
    }

    switch (input) {
      case 0: // daily 1
        getElementValue('everyXDays')
        setInterval(null)
        setByWeekDays([])
        setIsDailySelected({
          everyDay : true,
          weekDaysSelected : false
        })
        break
      case 1: // daily 2
        getElementValue('everyXDays')
        setByWeekDays(['mo', 'tu', 'we', 'th', 'fr'])
        setInterval(null)
        setIsDailySelected({
          everyDay : false,
          weekDaysSelected : true
        })
        break
      case 2: // monthly 1
        getElementValue('daySelect')
        getElementValue('monthSelect')
        getElementValue('monthlyInterval')
        setBySetPos(1)
        setByWeekDays([])
        setInterval(1)
        setisMontlySelected({
          customDays : false,
          days: true
        })
        setByMonthDay(null)

        break
      case 3: // monthly 2
        getElementValue('daySelect')
        getElementValue('monthlyInterval')
        setByWeekDays(['su'])
        setInterval(1)
        setBySetPos(1)
        setByMonth(null)
        setisMontlySelected({
          customDays : true,
          days: false
        })
        setByMonthDay(null)
        break
      case 4: // yearly 1
        getElementValue('selectMonth2')
        getElementValue('bySetPos')
        getElementValue('dayChoice')
        setByMonth(1)
        setByMonthDay(1)
        setBySetPos(null)
        setIsYearlySelected({
          monthSelected: true,
          weekDaysSelected: false,
        })

        break
      case 5: // yearly 2
        getElementValue('selectMonth1')
        getElementValue('daySelectForMonth')
        setByMonth(null)
        setByMonthDay(null)
        setInterval(1)
        setByWeekDays(['su'])
        setIsYearlySelected({
          monthSelected: false,
          weekDaysSelected: true,
        })
        break
      default:
        break
    }
  }

  const daysOfTheWeekSelectHandler = (event) => {
    const selectedDay = event.target.value
    const updatedDaysSet = new Set(byWeekDays)

    if (updatedDaysSet.has(selectedDay)) {
      updatedDaysSet.delete(selectedDay)
    } else {
      updatedDaysSet.add(selectedDay)
    }

    // Convert the updated set back to an array
    const updatedDaysArray = Array.from(updatedDaysSet)
    setByWeekDays(updatedDaysArray)
  }

  let patternForm
  if (frequency === 'daily') {
    patternForm = (
      <>
        <div className='radioPattern'>
          <input
            aria-label='Custom Days'
            checked={isDailySelected.everyDay}
            className='frequencyRadio'
            disabled={!props.activateEdit}
            id='everyFewDays'
            name='radioGroup'
            onChange={() => radioSelectHandler(0)}
            type='radio'
          />
          <span>
            {' '}
            Every
            <input
              aria-label='days'
              className='daysInput'
              disabled={!props.activateEdit}
              id='everyXDays'
              min='1'
              onChange={frequencyChoiceHandler}
              type='number'
              value={interval}
            />{' '}
            day(s)
          </span>
        </div>
        <div className='radioPattern'>
          <input
            aria-label='Weekdays'
            checked={isDailySelected.weekDaysSelected}
            className='frequencyRadio'
            disabled={!props.activateEdit}
            id='weekdays'
            name='radioGroup'
            onChange={() => radioSelectHandler(1)}
            type='radio'
          />
          <span> Every Weekday</span>
        </div>
      </>
    )
  } else if (frequency === 'weekly') {
    patternForm = (
      <div>
        <span>
          Recur every
          <input
            aria-label='weeks'
            className='daysInput'
            disabled={!props.activateEdit}
            min='1'
            onChange={frequencyChoiceHandler}
            type='number'
            value={interval}
          />{' '}
          week(s) on:
        </span>

        <div className='daysCheckboxes'>
          <div>
            <input
              aria-label='Sunday'
              checked={byWeekDays.includes('su')}
              disabled={!props.activateEdit}
              id='Sunday'
              onChange={daysOfTheWeekSelectHandler}
              type='checkbox'
              value='su'
            />
            <label htmlFor='Sunday'>Sunday</label>
          </div>
          <div>
            <input
              aria-label='Monday'
              checked={byWeekDays.includes('mo')}
              disabled={!props.activateEdit}
              id='Monday'
              onChange={daysOfTheWeekSelectHandler}
              type='checkbox'
              value='mo'
            />
            <label htmlFor='Monday'>Monday</label>
          </div>
          <div>
            <input
              aria-label='Tuesday'
              checked={byWeekDays.includes('tu')}
              disabled={!props.activateEdit}
              id='Tuesday'
              onChange={daysOfTheWeekSelectHandler}
              type='checkbox'
              value='tu'
            />
            <label htmlFor='Tuesday'>Tuesday</label>
          </div>
          <div>
            <input
              aria-label='Wednesday'
              checked={byWeekDays.includes('we')}
              disabled={!props.activateEdit}
              id='Wednesday'
              onChange={daysOfTheWeekSelectHandler}
              type='checkbox'
              value='we'
            />
            <label htmlFor='Wednesday'>Wednesday</label>
          </div>
          <div>
            <input
              aria-label='Thursday'
              checked={byWeekDays.includes('th')}
              disabled={!props.activateEdit}
              id='Thursday'
              onChange={daysOfTheWeekSelectHandler}
              type='checkbox'
              value='th'
            />
            <label htmlFor='Thursday'>Thursday</label>
          </div>
          <div>
            <input
              aria-label='Friday'
              checked={byWeekDays.includes('fr')}
              disabled={!props.activateEdit}
              id='Friday'
              onChange={daysOfTheWeekSelectHandler}
              type='checkbox'
              value='fr'
            />
            <label htmlFor='Friday'>Friday</label>
          </div>
          <div>
            <input
              aria-label='Saturday'
              checked={byWeekDays.includes('sa')}
              disabled={!props.activateEdit}
              id='Saturday'
              onChange={daysOfTheWeekSelectHandler}
              type='checkbox'
              value='sa'
            />
            <label htmlFor='Saturday'>Saturday</label>
          </div>
        </div>
      </div>
    )
  } else if (frequency === 'monthly') {
    patternForm = (
      <>
        <div className='radioPattern'>
          <input
            aria-label='Custom Days'
            checked={isMontlySelected.days}
            className='frequencyRadio'
            disabled={!props.activateEdit}
            id='fixedDayOfEachMonth'
            name='radioGroup'
            onChange={() => radioSelectHandler(2)}
            type='radio'
          />

          <span> Day </span>
          <input
            aria-label='Day'
            className='daysInput'
            disabled={!props.activateEdit}
            id='daySelect'
            max='31'
            min='1'
            onChange={byMonthDaySelect}
            type='number'
            value={byMonthDay}
          />
          <span> of every </span>
          <input
            aria-label='Months'
            className='daysInput'
            disabled={!props.activateEdit}
            id='monthSelect'
            min='1'
            onChange={frequencyChoiceHandler}
            type='number'
            value={interval}
          />

          <span> month(s) </span>
        </div>

        <div className='radioPattern'>
          <input
            aria-label='Custom Days'
            checked={isMontlySelected.customDays}
            className='frequencyRadio'
            disabled={!props.activateEdit}
            id='customDays'
            name='radioGroup'
            onChange={() => radioSelectHandler(3)}
            type='radio'
          />

          <span> The </span>
          <select
            aria-label='Month'
            className='monthlydaysInput'
            disabled={!props.activateEdit}
            id='bySetPosMonth'
            onChange={setBySetPosHandler}
            value={bySetPos}
          >
            {intervalChoice}
          </select>

          <select
            aria-label='Start'
            className='monthlydaysInput'
            disabled={!props.activateEdit}
            id='selectMinutesStart'
            onChange={setByWeekDayHandler}
            value={byWeekDays}
          >
            {singleDayChoice}
          </select>

          <span> of every</span>
          <input
            aria-label='Monthly'
            className='daysInput'
            disabled={!props.activateEdit}
            id='monthlyInterval'
            min='1'
            onChange={frequencyChoiceHandler}
            type='number'
            value={interval}
          />

          <span>month(s)</span>
        </div>
      </>
    )
  } else if (frequency === 'yearly') {
    patternForm = (
      <>
        <span>
          Recur every
          <input
            aria-label=' years'
            className='daysInput'
            disabled={!props.activateEdit}
            min='1'
            onChange={frequencyChoiceHandler}
            type='number'
            value={interval}
          />{' '}
          year(s)
        </span>
        <div className='radioPattern'>
          <input
            aria-label='Custom Days'
            checked={isYearlySelected.monthSelected}
            className='frequencyRadio'
            disabled={!props.activateEdit}
            id='fixedDayOfEachMonth'
            name='radioGroup'
            onChange={() => radioSelectHandler(4)}
            type='radio'
          />

          <span>
            {' '}
            On:
            <select
              aria-label='Month'
              className='monthlydaysInput'
              disabled={!props.activateEdit}
              id='selectMonth1'
              onChange={setByMonthHandler}
              value={byMonth}
            >
              {monthChoice}
            </select>
            <input
              aria-label='Month'
              className='daysInput'
              disabled={!props.activateEdit}
              id='daySelectForMonth'
              max='31'
              min='1'
              onChange={byMonthDaySelect}
              type='number'
              value={byMonthDay}
            />
          </span>
        </div>

        <div className='radioPattern'>
          <input
            checked={isYearlySelected.weekDaysSelected}
            className='frequencyRadio'
            disabled={!props.activateEdit}
            id='fixedDayOfEachMonth'
            name='radioGroup'
            onChange={() => radioSelectHandler(5)}
            type='radio'
          />
          <label htmlFor='fixedDayOfEachMonth'>Custom Days</label>
          <span>
            On the:
            <select
              aria-label='Month'
              className='monthlydaysInput'
              disabled={!props.activateEdit}
              id='bySetPos'
              onChange={setBySetPosHandler}
              value={bySetPos}
            >
              {intervalChoice}
            </select>
            <select
              aria-label='Day'
              className='monthlydaysInput'
              disabled={!props.activateEdit}
              id='dayChoice'
              onChange={setByWeekDayHandler}
              value={byWeekDays}
            >
              {singleDayChoice}
            </select>
            <span> of </span>
            <select
              aria-label='Month'
              className='monthlydaysInput'
              disabled={!props.activateEdit}
              id='selectMonth2'
              onChange={setByMonthHandler}
              value={byMonth}
            >
              {monthChoice}
            </select>
          </span>
        </div>
      </>
    )
  }
  const endDateRadioSelect = (input: any) => {
    const getElementValue = (id: string) => {
      const element = document.getElementById(id) as HTMLInputElement | null
      return element ? element.value : ''
    }
    switch (input) {
      case 0:
        setEndRadioSelection('noEndDate')
        setCount(null)
        setEndDate(null)
        setIsNoEndDate(true)
        getElementValue('endAfterCount')
        getElementValue('endBySelect')
        setDateRange(0)
        break
      case 1:
        setEndRadioSelection('endAfterCount')
        setEndDate(null)
        setIsNoEndDate(false)
        getElementValue('endBySelect')
        getElementValue('endAfterCount')
        setCount(1)
        setDateRange(1)
        break
      case 2:
        setEndRadioSelection('endBy')
        setCount(null)
        setIsNoEndDate(false)
        setEndDate(null)
        getElementValue('endAfterCount')
        setDateRange(2)
        break
      default:
        break
    }
  }

  const startDateSelectHandler = (event: any) => {
    setStartDate(event.target.value)
  }
  const endDateSelectHandler = (event: any) => {
    setEndDate(event.target.value)
  }
  const countChangeHanlder = (event: any) => {
    setCount(parseInt(event.target.value))
  }

  return (
    <>
      <fieldset className='recurrenceEvent'>
        <legend className='recurrenceEventLegend'>
          <div aria-label='Recurrence Pattern' tabIndex={0}>
            Recurrence Pattern
          </div>
          <span className='required'>*</span>
        </legend>
        <div className='patternAndFrequency'>
          <div className='frequency'>
            <div>
              <input
                aria-label='Daily'
                checked={frequency === 'daily'}
                className='frequencyRadio'
                disabled={!props.activateEdit}
                id='recurrenceFrequencyDaily'
                name='frequencyGroup'
                onChange={() => frequencySelectHandler('daily')}
                type='radio'
              />
              <span> Daily</span>
            </div>
            <div>
              <input
                aria-label='Weekly'
                checked={frequency === 'weekly'}
                className='frequencyRadio'
                disabled={!props.activateEdit}
                id='recurrenceFrequencyWeekly'
                name='frequencyGroup'
                onChange={() => frequencySelectHandler('weekly')}
                type='radio'
              />
              <span> Weekly</span>
            </div>
            <div>
              <input
                aria-label='Monthly'
                checked={frequency === 'monthly'}
                className='frequencyRadio'
                disabled={!props.activateEdit}
                id='recurrenceFrequencyMonthly'
                name='frequencyGroup'
                onChange={() => frequencySelectHandler('monthly')}
                type='radio'
              />
              <span> Monthly</span>
            </div>
            <div>
              <input
                aria-label='Yearly'
                checked={frequency === 'yearly'}
                className='frequencyRadio'
                disabled={!props.activateEdit}
                id='recurrenceFrequencyYearly'
                name='frequencyGroup'
                onChange={() => frequencySelectHandler('yearly')}
                type='radio'
              />
              <span> Yearly</span>
            </div>
          </div>

          <div className='pattern'>{patternForm}</div>
        </div>
      </fieldset>

      <p className='required'>{props.patternError}</p>

      <fieldset className='recurrenceEvent'>
        <legend className='recurrenceEventLegend'>
          <div aria-label='Range of recurrence' tabIndex={0}>
            Range of recurrence
          </div>
          <span className='required'>*</span>
        </legend>

        <div className='rangeRecurrence'>
          <div className='row'>
            <div className='col-lg-6 col-sm-12'>
              <div>
                <span>Start: </span>
                <input
                  aria-label='Start'
                  className='rangedaysInput'
                  disabled={!props.activateEdit}
                  max='2999-12-31'
                  min={todayDate}
                  onChange={startDateSelectHandler}
                  type='date'
                  value={startDate}
                />
              </div>
            </div>

            <div className='col-lg-6 col-sm-12'>
              <div className='endSelection'>
                <div>
                  <input
                    aria-label='No End Date'
                    checked={dateRange === 0}
                    className='frequencyRadio'
                    disabled={!props.activateEdit}
                    id='noEndDate'
                    name='endRadio'
                    onChange={() => endDateRadioSelect(0)}
                    type='radio'
                  />
                  <span>No End Date</span>
                </div>

                <div>
                  <input
                    aria-label='End After Ocurrences'
                    checked={dateRange === 1}
                    className='frequencyRadio'
                    disabled={!props.activateEdit}
                    id='endAfterOcurrences'
                    name='endRadio'
                    onChange={() => endDateRadioSelect(1)}
                    type='radio'
                  />
                  <span>End after: </span>
                  <input
                    aria-label='ocurrences'
                    className='daysInput'
                    disabled={!props.activateEdit}
                    id='endAfterCount'
                    min='1'
                    onChange={countChangeHanlder}
                    type='number'
                    value={count}
                  />
                  <span> ocurrence(s)</span>
                </div>

                <div>
                  <input
                    aria-label='End By'
                    checked={dateRange === 2}
                    className='frequencyRadio'
                    disabled={!props.activateEdit}
                    id='endBy'
                    name='endRadio'
                    onChange={() => endDateRadioSelect(2)}
                    type='radio'
                  />
                  <span>End by: </span>

                  <input
                    aria-label='Date'
                    className='rangedaysInput'
                    disabled={!props.activateEdit}
                    id='endBySelect'
                    max='2999-12-31'
                    min={startDate}
                    onChange={endDateSelectHandler}
                    type='date'
                    value={endDate}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <p className='required'>{props.rangeError}</p>
    </>
  )
}
export default RecurrencePattern
